import fetchJSON from '@gaia/utils/fetchJSON';
import getCSRFToken from './getCSRFToken';

interface UserProfileSettings {
    email: string;
    unitSystem?: string;
    coordinateFormat?: string;
}

export default async function saveUserProfileSetting({
    email,
    unitSystem,
    coordinateFormat,
}: UserProfileSettings) {
    const body = JSON.stringify({
        email,
        ...(unitSystem && {setting_distance_units: unitSystem}),
        ...(coordinateFormat && {setting_coordinate_format: coordinateFormat}),
    });
    const csrf = getCSRFToken();
    return await fetchJSON('/api/user/profile/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...(csrf && {'X-CSRFToken': csrf}),
        },
        body,
    });
}
